import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';

/* 工具方法，不与功能相关 */
const ENABLE_LOG = localStorage.ZHINI_LOG_ENABLE_FLAG;
export default {
  IsIOS: (function () {
    if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      return true;
    } else {
      return false;
    }
  })(),
  IsIE: (function () {
    if (!!window.ActiveXobject || "ActiveXObject" in window) {
      return true;
    } else {
      return false;
    }
  })(),
  IsIE11: (function () {
    if (/Trident\/7\./.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  })(),
  IsPcMode: (() => {
    const userAgentInfo = window.navigator.userAgent;
    const Agents = [
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod",
      "Harmony"
    ];
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        return false;
      }
    }
    return true;
  })(),
  IsWeiXin: (() => {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  })(),
  isWindowsPC: (() => {
    const userAgentInfo = window.navigator.userAgent;
    return /Windows NT/.test(userAgentInfo) 
  })(),
  isUCBrowser: (() => {
    const userAgentInfo = window.navigator.userAgent;
    return /UBrowser/i.test(userAgentInfo);
  })(),
  replaceAll(stringOrg, s1, s2) {
    return stringOrg.replace(new RegExp(s1, "gm"), s2);
  },
  replaceTag(msg){
    return msg.replace(/</g, "&lt;").replace(/>/g, "&gt;")
  },
  replaceSpecialTag(msg) {
    return this.replaceAll(msg, '<style', '&lt;style')
        .replace(/<\/style>/g, '&lt;/style&gt;')
        .replace(/<iframe/g, '&lt;iframe')
        .replace(/<\/iframe>/g, '&lt;/iframe&gt;')
        .replace(/<script/g, '&lt;script')
        .replace(/<\/script>/g, '&lt;/script&gt;');
  },
  getParameterByName: (name) => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(window.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  },
  getAllparams: () => {
    const url = window.location.href,
      param = {};
    if (url.indexOf("?") != -1) {
      url
        .split("?")[1]
        .split(/[&#]/)
        .forEach(function (param_str) {
          (function () {
            param[this[0]] = decodeURIComponent(this[1]);
          }).call(param_str.split("="));
        });
    }
    return param;
  },
  formatDate(date, fmt, utc) {
    fmt = fmt || "yyyy-mm-dd hh:MM:ss";
    var o = {
      "m+": date[utc ? "getUTCMonth" : "getMonth"]() + 1, //月份
      "d+": date[utc ? "getUTCDate" : "getDate"](), //日
      "h+": date[utc ? "getUTCHours" : "getHours"](), //小时
      "M+": date[utc ? "getUTCMinutes" : "getMinutes"](), //分
      "s+": date[utc ? "getUTCSeconds" : "getSeconds"](), //秒
      "q+": Math.floor((date[utc ? "getUTCMonth" : "getMonth"]() + 3) / 3), //季度
      S: date[utc ? "getUTCMilliseconds" : "getMilliseconds"](), //毫秒
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date[utc ? "getUTCFullYear" : "getFullYear"]() + "").substr(
          4 - RegExp.$1.length
        )
      );
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return fmt;
  },
  formatStorageSize(value = 0, fixedNum = 2) {
    if (value < 1024) {
      return value + "B";
    }
    value = value / 1024;
    if (value < 1024) {
      return value.toFixed(fixedNum) + "KB";
    }
    return (value / 1024).toFixed(fixedNum) + "MB";
  },
  scrollDownEnd(length, duration) {
    const element = document.getElementById("msg-wrapper");
    if (duration == 0) {
      element.scrollTop = length || 99999999999999;
    }
    setTimeout(() => {
      element.scrollTop = length || 99999999999999;
    }, duration || 300);
  },
  log(msg) {
    ENABLE_LOG && console.log("ZHINI IFRAME LOG --- " + msg);
  },
  changePromoteDialog: function (params) {
    if (!params) {
      document.querySelector(".promote-dialog").style.display = "none";
      return;
    }
    document.querySelector(".dialog-body").innerHTML = params.content;
    document.querySelector(".promote-dialog").style.display = "block";
    document.querySelector(".cancel-btn").style.display = params.noCancel
      ? "none"
      : "";
    document.querySelector(".ok-btn").onclick = function () {
      document.querySelector(".promote-dialog").style.display = "none";
      params.cb && params.cb();
    };
    document.querySelector(".cancel-btn").onclick = function () {
      document.querySelector(".promote-dialog").style.display = "none";
    };
  },
  isImageFile(fileName) {
    // 正则表达式，匹配常见的图片格式后缀
    const imageFormatsRegex = /\.(jpg|jpeg|png|gif|bmp|tiff|webp)$/i;

    // 使用正则表达式的 test 方法进行匹配
    if (imageFormatsRegex.test(fileName)) {
      return true;
    } else {
      return false;
    }
  },
  isVideoFile(fileName) {
    // 正则表达式，匹配常见的图片格式后缀
    const videoFormatsRegex = /\.(m4v|M4V|mp4|MP4|mov|MOV|wmv|WMV|mkv|WKV|webm|WEBM)$/i;

    // 使用正则表达式的 test 方法进行匹配
    if (videoFormatsRegex.test(fileName)) {
      return true;
    } else {
      return false;
    }
  },
  base64ToFile(base64, fileName) {
    // 将 base64 按照逗号分割，获取前缀和文件内容部分
    const data = base64.split(',');
    // 利用正则表达式从前缀中获取图片的类型信息（如 image/png、image/jpeg 等）
    const type = data[0].match(/:(.*?);/)[1];
    // 从图片的类型信息中获取具体的文件格式后缀（如 png、jpeg 等）
    const suffix = type.split('/')[1];
    // 使用 atob() 对 base64 数据进行解码，得到文件数据流（以字符串形式输出）
    const bstr = atob(data[1]);
    // 获取解码结果字符串的长度
    let n = bstr.length;
    // 创建一个与文件数据流字符串长度相同的 8 位无符号整型数组
    const u8arr = new Uint8Array(n);
    // 通过循环将整型数组的每个元素填充为解码结果字符串对应位置字符的 UTF-16 编码单元
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    // 利用 File 构造函数创建 File 对象
    const file = new File([u8arr], `${fileName}.${suffix}`, { type: type });
  
    return file;
  },
  hasUnclosedATag(htmlString) {
    // 正则表达式匹配不完整的<a>标签，即没有</a>闭合的<a>标签
    const unclosedATagPattern = /<a\s+[^>]*[^>]$/;
    // 使用正则表达式测试字符串
    return unclosedATagPattern.test(htmlString);
  },
  linkifyText(text) {
    // 找出所有<a>标签的起始和结束位置
    const aTagRegex = /<a\b[^>]*>|<\/a>/g;
    let aTagPositions = [];
    let stack = 0; // 用于跟踪<a>标签的嵌套
    let match;
    // 收集所有<a>标签的位置
    while ((match = aTagRegex.exec(text)) !== null) {
      if (match[0].startsWith('<a')) {
        stack++;
      } else {
        stack--;
      }
      if (stack > 0) {
        aTagPositions.push({
          start: match.index,
          end: aTagRegex.lastIndex - 4, // -4 调整结束位置，排除</a>的长度
        });
      }
    }
    // 匹配所有潜在的URL
    const urlRegex = /\b(?:https?|ftp|file|gopher|news|nntp|telnet|rtsp|svn|git|ssh|imap|ircs?|irc|gopher|ws|wss|weixin|mailto|data):\/\/[^\s<>"`{}|^\u4e00-\u9fff;,，。；、]*[^\u4e00-\u9fff\s<>"`{}|^;,.，。；、]/g;
    let lastUrlMatchIndex = 0;
  
    // 替换URL为超链接，同时排除<a>标签内的URL
    let linkifiedText = text.replace(urlRegex, (url, index) => {
      // 检查当前URL是否在<a>标签内
      let insideATag = false;
      for (const { start, end } of aTagPositions) {
        if (index > start && index <= end) {
          insideATag = true;
          break;
        }
      }
      // 如果不在<a>标签内，则替换为<a>标签
      if (!insideATag) {
        // 确保不会错误地截断已有的<a>标签
        const textSinceLastMatch = text.substring(lastUrlMatchIndex, index);
        const hasOpenATag = /<a\b/.test(textSinceLastMatch);
        const hasCloseATag = /\<\/a>/.test(textSinceLastMatch);
        if (hasOpenATag && !hasCloseATag) {
          // 如果在当前匹配的URL之前有打开的<a>标签但没有闭合，则不替换
          return url;
        }
        lastUrlMatchIndex = index + url.length;
        return `<a href="${url}" target="_blank">${url}</a>`;
      }
      // 如果在<a>标签内或不需要替换，则保留原样
      return url;
    });
    
    return linkifiedText;
  },
  blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  },
  // 计算文本的宽度
  calculateTextWidth(text) {
    const span = document.createElement('span');
    span.style.visibility = 'hidden';
    span.style.whiteSpace = 'nowrap';
    span.innerText = text;
    document.body.appendChild(span);
    const width = span.offsetWidth;
    document.body.removeChild(span);
    return width;
  },
  truncateFileName(fileName, containerWidth) {
    const ellipsis = '...';
    const fileNameWidth = this.calculateTextWidth(fileName); // 计算文件名的宽度
  
    if (fileNameWidth <= containerWidth) {
      return fileName; // 如果文件名宽度小于容器宽度，直接返回文件名
    }
  
    const endCharsLength = 12; // 保留的尾部字符长度
    const availableWidth = containerWidth - this.calculateTextWidth(ellipsis) - endCharsLength; // 可用宽度
  
    let start = '';
    let end = fileName;
    let truncatedFileName = '';
  
    // 从文件名的开头逐个字符添加，直到剩余宽度不足以容纳省略号和尾部字符
    for (let i = 0; i < fileName.length; i++) {
      start += fileName[i];
      end = fileName.slice(i + 1);
      if (this.calculateTextWidth(start + ellipsis + end.substring(end.length - endCharsLength)) > containerWidth) {
        break;
      }
      truncatedFileName = start + ellipsis + end.substring(end.length - endCharsLength);
    }
  
    return truncatedFileName;
  },
  hasSensitiveWords(str) {
    if (str == '' || str == undefined) return false;
    str = str.replace(/\s+/g,'');
    const key = 'zhiniwebplugin';
    // const encrytedText = AES.encrypt(originText, key).toString(); //加密
    const encrytedWords = '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'; //密文
    let words = AES.decrypt(encrytedWords, key).toString(encUtf8); //解密
    var array = words.split(','), len = array.length;
    for (var i = 0; i < len; i++) {
      var item = array[i];
      if (str.indexOf(item) >= 0 && item != '') {
        return item;
      }
    }
    return false;
  }
};


// WEBPACK FOOTER //
// ./src/js/utils.js